<template>
  <div>
    <div
      class="
        ht-55
        bg-gray-100
        d-flex
        align-items-center
        justify-content-between
        wd-100p
        pd-x-10
        bd-b
      "
    >
      <div class="wd-85p d-flex align-items-center">
        Шалгуур үзүүлэлтээр хайх
        <Input v-model="srchModel" style="width: 50%" class="mg-l-5"></Input>
      </div>
      <div class="ml-g-auto btn-group">
        <button @click="filterTsks(1)" class="btn btn-xs btn-primary">
          Хайх
        </button>
        <button @click="filterTsks(0)" class="btn btn-xs btn-light">
          Бүгд
        </button>
        <button @click="showAttach()" class="btn btn-xs btn-success">
          Файл харах
        </button>
      </div>
    </div>
    <div
      style="overflow: auto; max-height: calc(100vh - 170px)"
      class="bg-white pd-10"
    >
      <table class="tbl-attest">
        <thead style="text-align: center">
          <tr>
            <th rowspan="2" style="width: 50px">№</th>
            <th rowspan="2" style="width: 10%">Шалгуур үзүүлэлт</th>
            <th rowspan="2" style="width: 10%">Хэмжих нэгж</th>
            <th rowspan="2">Тайлбар</th>
            <th style="width: 100px" rowspan="2">Профессор багшийн оноо</th>
            <th style="width: 30%" rowspan="2">Хийж гүйцэтгэсэн ажил</th>
            <th style="width: 100px" rowspan="2">Өөрийн үнэлсэн оноо</th>
            <th style="width: 200px" colspan="2">Хяналтын үнэлгээ</th>
          </tr>
          <tr>
            <th style="width: 100px">Тэнхим</th>
            <th style="width: 100px">Салбар комисс</th>
          </tr>
        </thead>
        <tbody>
          <tr class="font-weight-bold">
            <td></td>
            <td colspan="3">{{ task.name }}</td>
            <td class="text-center">{{ task.maxPoint }}</td>
            <td></td>
            <td class="text-center">{{ task.i2 }}</td>
            <td class="text-center">{{ task.i3 }}</td>
            <td class="text-center">{{ task.i4 }}</td>
          </tr>

          <template v-for="(t, i) in tasks">
            <tr :key="`gr_${i}`" style="background: #d6e9fa">
              <td></td>
              <td colspan="2" class="font-weight-bold">{{ t.name }}</td>
              <td></td>
              <td class="text-center">{{ t.maxPoint }}</td>
              <td></td>
              <td class="text-center">{{ t.sumi2 }}</td>
              <td class="text-center">{{ t.sumi3 }}</td>
              <td class="text-center">{{ t.sumi4 }}</td>
            </tr>
            <tr v-for="(ts, ii) in t.tsks" :key="`${i}_dotr${ii}`">
              <td></td>
              <td>{{ ts.task }}</td>
              <td>{{ ts.taskEn }}</td>
              <td>{{ ts.taskDesc }}</td>
              <td class="text-center">{{ ts.i1 }}</td>
              <td class="">
                
                <div v-if="ts.taskDescEn!=null" v-html="ts.taskDescEn.replace(/(?:\r\n|\r|\n)/g,'<br>')"></div>
                <a v-if="ts.defaultAttachmentId>0" @click="$emit('on-attach', ts.defaultAttachmentId)" role="button" class="btn btn-xs btn-success">
                    <feather class="mg-r-5" type="eye"></feather>файл харах
                </a>
              </td>
              <td @click="showDetail(ts, 1)" class="text-center" role="button">
                {{ ts.i2 }}
                <feather
                  v-if="
                    parentTask.column != null &&
                    parentTask.column.shortName == 'ӨҮ'
                  "
                  type="clipboard"
                  class="wd-20-f ht-20-f mg-l-5"
                ></feather>
              </td>
              <td @click="showDetail(ts, 2)" class="text-center" role="button">
                {{ ts.i3 }}
                <feather
                  v-if="
                    parentTask.column != null &&
                    parentTask.column.shortName == 'ТҮ'
                  "
                  type="users"
                  class="wd-20-f ht-20-f mg-l-5"
                ></feather>
              </td>
              <td @click="showDetail(ts, 3)" class="text-center" role="button">
                {{ ts.i4 }}
                <feather
                  v-if="
                    parentTask.column != null &&
                    parentTask.column.shortName == 'СК'
                  "
                  type="user-check"
                  class="wd-20-f ht-20-f mg-l-5"
                ></feather>
              </td>
            </tr>
          </template>
        </tbody>
      </table>

      <b-modal :title="dtl.title" v-model="dtl.modal">
        <h3>{{ dtl.obj.task }}</h3>
        <div v-if="dtl.mode == 1" class="text-muted mg-b-10">
          {{ dtl.obj.taskDesc }}
        </div>
        <div v-else class="text-muted mg-b-10">
        
          <div v-if="dtl.obj.taskDescEn!=null" v-html="dtl.obj.taskDescEn.replace(/(?:\r\n|\r|\n)/g,'<br>')"></div>
        </div>
        <Form v-if="dtl.mode == 1" label-position="top" label-width="100%">
          <FormItem label="Хийж гүйцэтгэсэн ажил">
            <Input
              v-model="dtl.obj.taskDescEn"
              type="textarea"
              :rows="6"
            ></Input>
          </FormItem>
        </Form>
        <Form v-if="dtl.mode == 1" label-position="right" label-width="160px">
          <FormItem label="Хавсралт">
            <simple-uploader
              :propObjectId="6"
              :propObjectTypeId="6"
              @on-success="fileUploadedSetting"
              class="wd-100p"
            >
              <div slot="trigger" class="wd-100p">
                <a v-if="dtl.obj.defaultAttachmentId == 0 || dtl.obj.defaultAttachmentId == null"
                  class="dropdown-item" >Компьютероос хуулах
                </a>
                <div v-else class="btn-group wd-100p">
                  <div class="btn btn-outline-success" @click.stop="dtl.modal = false; $emit('on-attach', dtl.obj.defaultAttachmentId)">
                    <feather type="eye"></feather>Файл харах
                  </div>
                  <div class="btn btn-danger" @click.prevent.stop="dtl.obj.defaultAttachmentId = null">
                    <feather type="x"></feather>Салгах
                  </div>
                </div>
              </div>
            </simple-uploader>
          </FormItem>
        </Form>
        <Form label-position="right" label-width="160px">
          <FormItem label="Оноо">
            <InputNumber
              v-if="dtl.mode == 1"
              v-model="dtl.obj.i2"
              :max="dtl.obj.i1"
            ></InputNumber>
            <InputNumber
              v-else-if="dtl.mode == 2"
              v-model="dtl.obj.i3"
              
            ></InputNumber>
            <!-- :max="dtl.obj.i1" -->
            <InputNumber
              v-else-if="dtl.mode == 3"
              v-model="dtl.obj.i4"
              
            ></InputNumber>
            
            <!-- :max="dtl.obj.i1" 2023-01-03 салбар комисс хязгааргүй оноо тавьж болно гэв. -->
          </FormItem>
        </Form>
        <template #modal-footer>
          <div v-show="dtl.mode == 1">Хамгийн ихдээ {{ dtl.obj.i1 }} оноо өгөх боломжтой</div>
          <div class="mg-l-auto btn-group">
            <button
              @click="dtl.modal = false"
              type="button"
              class="btn btn-danger btn-xs btn-uppercase"
            >
              Хаах
            </button>
            <button
              @click="saveData()"
              type="button"
              class="btn btn-primary btn-xs btn-uppercase"
            >
              Хадгалах
            </button>
          </div>
        </template>
      </b-modal>

      <file-dialog
        :show="fileDialog.show"
        :id="fileDialog.id"
        @on-hide="fileDialog.show = false"
      />
    </div>
  </div>
</template>

<script>
import { request } from "@/api/all";
var _ = require("lodash");

import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

import "element-ui/lib/theme-chalk/index.css";
import { Form, Input, FormItem, InputNumber, Message } from "element-ui";

export default {
  components: {
    Form,
    Input,
    FormItem,
    InputNumber,
    simpleUploader: () => ({
      component: import("@/components/modules/media/simpleUploader.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    fileDialog: () => ({
      component: import("@/components/modules/media/preview.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  props: {
    parentTask: {
      type: Object,
      default: () => {},
    },
    box: {
      type: Object,
      default: () => {},
    },
    prms: {
      type: Object,
      default: () => {},
    },
    obj: {
      type: Object,
      default: () => {},
    },
    activeBox: {
      type: Object,
      default: () => {},
    },
    detailSettingProp: {
      type: Object,
      default: () => null,
    },
  },

  data() {
    return {
      srchModel: "",
      task: {
        name: "",
        maxPoint: 0,
        i2: 0,
        i3: 0,
        i4: 0,
      },
      tasks: [],
      tasksReal: [],
      coreSearchModel: {},
      dtl: {
        obj: {},
        mode: null,
        title: "",
        modal: false,
      },
      fileDialog: {
        id: null,
        show: false,
      },
    };
  },

  mounted() {
    this.init();
  },
  methods: {
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;
      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    init() {
      this.toggleBodyClass("addClass", "dynamic-locker");

      request({
        api: { method: "POST", url: "taskCore/CoreBoxInTaskList" },
        data: {
          id: this.box.id,
          skip: 0,
          size: 2000,
          model: this.coreSearchModel,
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        //this.tasks = res.data.tasks;
        //console.log( res.data.tasks.map(d => { return {id: d.locTypeId, name: d.locTypeName}}), _.uniqBy(res.data.tasks.map(d => { return {id: d.locTypeId, name: d.locTypeName}}), "id") );
        res.data.tasks = _.orderBy(res.data.tasks, ["i5"], ["asc"]);
        res.data.tasks.forEach((element) => {
          element.i1 = element.i1 == null ? 0 : element.i1;
          element.i4 = element.i4 == null ? 0 : element.i4;
          element.i2 = element.i2 == null ? 0 : element.i2;
          element.i3 = element.i3 == null ? 0 : element.i3;
        });

        let itms = _.uniqBy(
          res.data.tasks.map((d) => {
            return { id: d.locTypeId, name: d.locTypeName };
          }),
          "id"
        );
        itms = itms.map((x) => ({
          ...x,
          tsks: res.data.tasks.filter((z) => z.locTypeId == x.id),
          maxPoint: res.data.tasks
            .filter((z) => z.locTypeId == x.id)
            .reduce((sum, st) => sum + parseInt(st.i1), 0),

          sumi2: res.data.tasks
            .filter((z) => z.locTypeId == x.id)
            .reduce((sum, st) => sum + parseInt(st.i2), 0),
          sumi3: res.data.tasks
            .filter((z) => z.locTypeId == x.id)
            .reduce((sum, st) => sum + parseInt(st.i3), 0),
          sumi4: res.data.tasks
            .filter((z) => z.locTypeId == x.id)
            .reduce((sum, st) => sum + parseInt(st.i4), 0),
        }));
        //console.log('itms', itms);
        this.task = {
          name: "Нийт оноо",
          maxPoint: itms.reduce((sum, st) => sum + parseInt(st.maxPoint), 0),
          i2: itms.reduce((sum, st) => sum + parseInt(st.sumi2), 0),
          i3: itms.reduce((sum, st) => sum + parseInt(st.sumi3), 0),
          i4: itms.reduce((sum, st) => sum + parseInt(st.sumi4), 0),
        };
        this.tasks = itms;
        this.tasksReal = res.data.tasks;

        //this.tasksCount = res.data.tasksCount;
        //this.allCount = res.data.allCount;
        //this.fetched = true;
        this.$emit("box-loaded", res.data);
        this.$emit("set-fullTask", true);
      });
    },
    showDetail(e, mode) {
      //this.toggleBodyClass("addClass", "dynamic-locker");
      // request({
      //     api: { method: "GET", url: "Task/TaskInheritedDetail" },
      //     params: { id: e.id, },
      //     store: this.$store
      // }).then(res => {
      //     this.toggleBodyClass("removeClass", "dynamic-locker");
      //this.dtl.obj= res.data.task;
      this.dtl.obj = e;
      this.dtl.mode = mode;
      if (mode == 1) {
        this.dtl.title = "Өөрийгөө үнэлэх";
      } else if (mode == 2) {
        this.dtl.title = "Хяналтын үнэлгээ - Тэнхим";
      } else if (mode == 3) {
        this.dtl.title = "Хяналтын үнэлгээ - Салбар комисс";
      }

      this.dtl.modal = true;
      //});
    },
    saveData() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      let _pnt = 0;

      if (this.dtl.mode == 1) {
        _pnt = this.dtl.obj.i2;
      } else if (this.dtl.mode == 2) {
        _pnt = this.dtl.obj.i3;
      } else if (this.dtl.mode == 3) {
        _pnt = this.dtl.obj.i4;
      }
      //console.log(this.dtl.obj.taskDesckEn);
      request({
        api: { method: "POST", url: "Attestat/SavePoint" },
        data: {
          id: this.dtl.obj.id,
          parentId: this.parentTask.id,
          point: _pnt,
          info: this.dtl.obj.taskDescEn,
          defaultAttachmentId: this.dtl.obj.defaultAttachmentId,
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if(res!=false){
            Message({ message: "Амжилттай", type: "success" });
        }
        this.filterTsks(0);
        if (this.tasksReal.filter((x) => x.id == this.dtl.obj.id).length > 0) {
          this.tasksReal.filter((x) => x.id == this.dtl.obj.id)[0]["i2"] =
            this.dtl.obj.i2;
          this.tasksReal.filter((x) => x.id == this.dtl.obj.id)[0]["i3"] =
            this.dtl.obj.i3;
          this.tasksReal.filter((x) => x.id == this.dtl.obj.id)[0]["i4"] =
            this.dtl.obj.i4;
          this.tasksReal.filter((x) => x.id == this.dtl.obj.id)[0][
            "taskDescEn"
          ] = this.dtl.obj.taskDescEn;
        }
        this.dtl.modal = false;
      });
    },
    filterTsks(mode) {
      if (mode == 0) {
        this.srchModel = "";
      }

      let _un = this.srchModel.toLowerCase();
      //console.log(_un, this.tasksReal);

      let _tsks = this.tasksReal.filter(
        (u) => u.task.toLowerCase().indexOf(_un) > -1
      );
      //console.log("ene ajilsnu");
      let itms = _.uniqBy(
        _tsks.map((d) => {
          return { id: d.locTypeId, name: d.locTypeName };
        }),
        "id"
      );
      //console.log("turln", itms);
      this.tasks = itms.map((x) => ({
        ...x,
        tsks: _tsks.filter((z) => z.locTypeId == x.id),
        maxPoint: _tsks
          .filter((z) => z.locTypeId == x.id)
          .reduce((sum, st) => sum + parseInt(st.i1), 0),

        sumi2: _tsks
          .filter((z) => z.locTypeId == x.id)
          .reduce((sum, st) => sum + parseInt(st.i2), 0),
        sumi3: _tsks
          .filter((z) => z.locTypeId == x.id)
          .reduce((sum, st) => sum + parseInt(st.i3), 0),
        sumi4: _tsks
          .filter((z) => z.locTypeId == x.id)
          .reduce((sum, st) => sum + parseInt(st.i4), 0),
      }));
      //console.log("haisan", itms);
      this.task = {
        name: "Нийт оноо",
        maxPoint: this.tasks.reduce(
          (sum, st) => sum + parseInt(st.maxPoint),
          0
        ),
        i2: this.tasks.reduce((sum, st) => sum + parseInt(st.sumi2), 0),
        i3: this.tasks.reduce((sum, st) => sum + parseInt(st.sumi3), 0),
        i4: this.tasks.reduce((sum, st) => sum + parseInt(st.sumi4), 0),
      };
    },
    showAttach() {
      this.fileDialog.id = this.parentTask.defaultAttachmentId;
      this.fileDialog.show = true;
    },

    fileUploadedSetting(e) {
      this.dtl.obj.defaultAttachmentId = e.uploadedAttachmentId;
    },
  },
};
</script>

<style>
.tbl-attest tr th,
.tbl-attest tr td {
  border: 1px solid #666;
  padding: 3px;
}
</style>